const BOM_WORKSPACE_SALES = 'sales';
const BOM_WORKSPACE_AVOR = 'avor';
const BOM_AVOR_SUBVIEW_PARTS_LIST = 'parts-list';

const BOM_WORKSPACE_DEFINITIONS = Object.freeze([
  Object.freeze({
    id: BOM_WORKSPACE_SALES,
    label: 'Verkauf',
    subcategories: Object.freeze([
      Object.freeze({ id: 'sort', label: 'Sortierung nach', kind: 'filter-card' }),
      Object.freeze({ id: 'display', label: 'Darstellungsfilter', kind: 'filter-card' })
    ])
  }),
  Object.freeze({
    id: BOM_WORKSPACE_AVOR,
    label: 'AVOR',
    subcategories: Object.freeze([
      Object.freeze({ id: BOM_AVOR_SUBVIEW_PARTS_LIST, label: 'Stückliste', kind: 'tab' })
    ])
  })
]);

function normalizeBomWorkspace(value) {
  return value === BOM_WORKSPACE_AVOR ? BOM_WORKSPACE_AVOR : BOM_WORKSPACE_SALES;
}

function normalizeBomAvorSubview(value) {
  return value === BOM_AVOR_SUBVIEW_PARTS_LIST
    ? value
    : BOM_AVOR_SUBVIEW_PARTS_LIST;
}

function bomWorkspaceDefinition(value) {
  const workspace = normalizeBomWorkspace(value);
  return BOM_WORKSPACE_DEFINITIONS.find(entry => entry.id === workspace)
    || BOM_WORKSPACE_DEFINITIONS[0];
}

function bomWorkspaceUsesTotalGrid(workspace, avorSubview = BOM_AVOR_SUBVIEW_PARTS_LIST) {
  return normalizeBomWorkspace(workspace) === BOM_WORKSPACE_AVOR
    && normalizeBomAvorSubview(avorSubview) === BOM_AVOR_SUBVIEW_PARTS_LIST;
}

function bomWorkspaceAllowsEdits(workspace, avorSubview = BOM_AVOR_SUBVIEW_PARTS_LIST) {
  return !bomWorkspaceUsesTotalGrid(workspace, avorSubview);
}

function flattenBomPresentationRows(presentation = {}) {
  return (presentation.sections || []).flatMap(section => (
    (section.groups || []).flatMap(group => group.rows || [])
  ));
}

/**
 * Liefert die Tabellenzeilen fuer den aktiven BOM-Bereich. Verkauf behaelt
 * die vorbereiteten Gruppen-/Ebenenzeilen. AVOR > Stueckliste verdichtet
 * dieselben bereits gefilterten und override-bereinigten Zeilen nochmals
 * ohne Gruppenschluessel zur flachen Total-Ansicht.
 */
function createBomWorkspaceGridRows(presentation = {}, options = {}) {
  const rows = flattenBomPresentationRows(presentation);
  if (!bomWorkspaceUsesTotalGrid(options.workspace, options.avorSubview)) return rows;
  return typeof options.aggregateRows === 'function'
    ? options.aggregateRows(rows, { groupMode: 'none' })
    : rows;
}

export {
  BOM_AVOR_SUBVIEW_PARTS_LIST,
  BOM_WORKSPACE_AVOR,
  BOM_WORKSPACE_DEFINITIONS,
  BOM_WORKSPACE_SALES,
  bomWorkspaceAllowsEdits,
  bomWorkspaceDefinition,
  bomWorkspaceUsesTotalGrid,
  createBomWorkspaceGridRows,
  flattenBomPresentationRows,
  normalizeBomAvorSubview,
  normalizeBomWorkspace
};
